interface SellerNextStepsGuideProps {
  isSuccess?: boolean;
  countdown?: number;
  className?: string;
}

export function SellerNextStepsGuide({ 
  isSuccess = false, 
  countdown = 0,
  className = '' 
}: SellerNextStepsGuideProps) {
  
  if (!isSuccess) {
    return null;
  }

  return (
    <div className={`space-y-6 ${className}`}>
      {/* 다음 단계 안내 */}
      <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
        <h3 className="text-[20px] font-semibold text-blue-700 mb-4">
          📋 다음 단계
        </h3>
        <ol className="space-y-2 text-[16px] text-blue-600">
          <li>1. <strong>심사 진행</strong> - 1~2영업일 소요</li>
          <li>2. <strong>승인 알림</strong> - 이메일/SMS로 알림</li>
          <li>3. <strong>매장 설정</strong> - 상품 등록 및 운영 설정</li>
          <li>4. <strong>서비스 시작</strong> - 고객 주문 받기 시작</li>
        </ol>
      </div>

      {/* 준비사항 안내 */}
      <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-200">
        <h3 className="text-[20px] font-semibold text-yellow-700 mb-4">
          📝 미리 준비하세요
        </h3>
        <ul className="space-y-2 text-[16px] text-yellow-600">
          <li>• <strong>매장 사진</strong> - 외관, 내부, 음식 사진</li>
          <li>• <strong>메뉴 정보</strong> - 가격, 설명, 알레르기 정보</li>
          <li>• <strong>운영 계획</strong> - 할인율, 수량, 운영 시간</li>
          <li>• <strong>결제 준비</strong> - 계좌 확인, 세금 신고 준비</li>
        </ul>
      </div>

      {/* 지원 정보 */}
      <div className="bg-green-50 p-6 rounded-lg border border-green-200">
        <h3 className="text-[20px] font-semibold text-green-700 mb-4">
          🤝 지원 서비스
        </h3>
        <ul className="space-y-2 text-[16px] text-green-600">
          <li>• <strong>매장 운영 가이드</strong> - 상세한 운영 방법 제공</li>
          <li>• <strong>마케팅 지원</strong> - 홍보 자료 및 이벤트 참여</li>
          <li>• <strong>고객 서비스</strong> - 24시간 고객센터 운영</li>
          <li>• <strong>정산 시스템</strong> - 투명한 매출 관리</li>
        </ul>
      </div>

      {/* 자동 이동 안내 */}
      {countdown > 0 && (
        <div className="text-center p-4 bg-gray-50 rounded-lg border">
          <p className="text-[16px] text-gray-600">
            <strong>{countdown}초</strong> 후 로그인 페이지로 이동합니다
          </p>
        </div>
      )}

      {/* 즉시 이동 버튼 */}
      <div className="flex gap-4 justify-center">
        <button
          onClick={() => window.location.href = '/login'}
          className="px-8 py-3 bg-[#51C854] text-white font-semibold text-[18px] rounded-lg hover:bg-[#46B649] transition-colors"
        >
          로그인하러 가기
        </button>
        <button
          onClick={() => window.location.href = '/'}
          className="px-8 py-3 bg-gray-200 text-gray-700 font-semibold text-[18px] rounded-lg hover:bg-gray-300 transition-colors"
        >
          홈으로 가기
        </button>
      </div>

      {/* 문의 정보 */}
      <div className="text-center pt-6 border-t border-gray-200">
        <p className="text-[14px] text-gray-500 mb-2">
          궁금한 점이 있으시면 언제든 문의해주세요
        </p>
        <div className="flex justify-center gap-6 text-[14px]">
          <span className="text-gray-600">📞 1588-1234</span>
          <span className="text-gray-600">✉️ seller@ecodeal.co.kr</span>
          <span className="text-gray-600">💬 카카오톡: 에코딜</span>
        </div>
      </div>
    </div>
  );
}